/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Property_Link_Rule_Type_NotapplicableInputs */

const en_enum_custom_property_link_rule_type_notapplicable = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_NotapplicableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property Link Rule Type Notapplicable`)
};

const de_enum_custom_property_link_rule_type_notapplicable = /** @type {(inputs: Enum_Custom_Property_Link_Rule_Type_NotapplicableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kein Link`)
};

/**
* | output |
* | --- |
* | "Property Link Rule Type Notapplicable" |
*
* @param {Enum_Custom_Property_Link_Rule_Type_NotapplicableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_property_link_rule_type_notapplicable = /** @type {((inputs?: Enum_Custom_Property_Link_Rule_Type_NotapplicableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Property_Link_Rule_Type_NotapplicableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_property_link_rule_type_notapplicable(inputs)
	return de_enum_custom_property_link_rule_type_notapplicable(inputs)
});